import React from 'react';
import '../style/formGroupSelectInput.css';
import '../style/formGroupSelectMultiple.css';

const FormGroupSelectMultiple = (props) => {

    if(props.disabled){
        return (
            <div className="form-group">
                <div className={props.LeftWrapper}>
                    <label className={"control-label.text-left formGroupSelectInput-label" +
                    (props.Required?' inputRequired':'')
                    }>
                        {props.Label}
                    </label>
                </div>
                <div className={props.CenterWrapper}>
                    <ul className="formGroupSelectMultiple-list-wrapper ">
                        {props.Options.map((item, index) => {
                            return <div key={index} className="formGroupSelectMultiple-select-option-wrapper">
                                <input name={props.Name}
                                       id={index + props.Name}
                                       checked={ props.HandleCheckedState(item.id, props.Name)}
                                       type="checkbox" className="formGroupSelectMultiple-check_box--disabled"
                                />
                                <label className={"formGroupSelectMultiple--disabled"}
                                       htmlFor={index + props.Name}>{item.name}</label>
                            </div>;
                        })}
                    </ul>
                </div>
                <div className={props.RightWrapper}></div>
            </div>
        )
    }

    return (
        <div className="form-group">
            <div className={props.LeftWrapper}>
                <label className={"control-label.text-left formGroupSelectInput-label" +
                (props.Required?' inputRequired':'')
                }>
                    {props.Label}
                </label>
            </div>
            <div className={props.CenterWrapper}>
                <ul className="formGroupSelectMultiple-list-wrapper">
                    {props.Options.map((item, index) => {
                        if (props.Name === 'selectedSolicitors')
                            return <div key={index} className="formGroupSelectMultiple-select-option-wrapper">
                                <input name={props.Name} checked={ props.HandleCheckedState(item.id, props.Name)}
                                       id={index + props.Name} type="checkbox"
                                       className="formGroupSelectMultiple-check_box"
                                       onChange={() => props.HandleInputChange(props.Name, item.id)}/>
                                <label className="formGroupSelectMultiple-select-option"
                                       htmlFor={index + props.Name}>{item.name}</label>
                            </div>;
                        else if (props.Name === 'selectedWorkSources') return <div key={index} className="formGroupSelectMultiple-select-option-wrapper">
                            <input name={props.Name} checked={ props.HandleCheckedState(item.id, props.Name)}
                                   id={index + props.Name}
                                   type="checkbox" className="formGroupSelectMultiple-check_box"
                                   onChange={() => props.HandleInputChange(props.Name, item.id)}/>
                            <label className="formGroupSelectMultiple-select-option"
                                   htmlFor={index + props.Name}>{item.name}</label>
                        </div>;
                        else if (props.Name === 'selectedDamages') return <div key={index} className="formGroupSelectMultiple-select-option-wrapper">
                            <input name={props.Name} checked={ props.HandleCheckedState(item.id, props.Name)}
                                   id={index + props.Name + props.premiumSettingSubSettingId}
                                   type="checkbox" className="formGroupSelectMultiple-check_box"
                                   onChange={() => props.HandleInputChange(props.Name, item.id)}/>
                            <label className="formGroupSelectMultiple-select-option"
                                   htmlFor={index + props.Name + props.premiumSettingSubSettingId}>{item.range}</label>
                        </div>;
                        else  return <div key={index} className="formGroupSelectMultiple-select-option-wrapper">
                                <input name={props.Name} checked={ props.HandleCheckedState(item.id, props.Name)}
                                       id={index + props.Name}
                                       type="checkbox" className="formGroupSelectMultiple-check_box"
                                       onChange={() => props.HandleInputChange(props.Name, item.id)}/>
                                <label className="formGroupSelectMultiple-select-option"
                                       htmlFor={index + props.Name}>{item.name}</label>
                            </div>;
                    })}
                </ul>
            </div>
            <div className={props.RightWrapper}></div>
        </div>
    )
};

export default FormGroupSelectMultiple;